import { useAuth } from '@ocula/auth';
import { Navigate, useParams } from 'react-router-dom';

// This currently just selects the first organisation as the home page to direct to.
export function RedirectToOrganizationHomePage() {
  const { organisations } = useAuth();
  const { region } = useParams();
  const orgHomePageUrl = `/${region}/${organisations?.[0]?.url ?? ''}`;
  return <Navigate to={orgHomePageUrl} replace />;
}
